module.exports = __webpack_public_path__ + "static/media/cobranca.e1f34eb7.png";